/**
 * IpcService - Production implementation of IIpcService
 *
 * Delegates to the existing ipcSend function from the IPC protocol layer.
 */

import type { PlaycastMessage, PlaycastMessageTarget } from '@playcastdotio/Messaging';
import type { IIpcService } from './IIpcService';
import { ipcSend } from '../../api/messaging/protocols/ipc';

export class IpcService implements IIpcService {
  public send(message: PlaycastMessage<PlaycastMessageTarget>): void {
    ipcSend(message);
  }
}
